import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewItemButton from './NewItemButton';
import addItem from './../../../actions/addItem';

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => bindActionCreators({ addItem }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewItemButton);
